module.exports = __webpack_public_path__ + "static/media/product.0254bb77.svg";